export default __webpack_public_path__ + "static/media/document-verified.3f8e4fac.svg";